import React from 'react';
import { InputText } from 'ui/InputText';
import { Title } from 'components/Title';
import { WhiteBlock } from 'components/WhiteBlock';
import styles from './BeneficiariesDetails.module.scss';
import { Button } from 'ui/Button';
import ModalUpdateLimit from './ModalUpdateLimit';

type Props = {
  id: string | undefined;
  modalLimitOpen: boolean;
  min_limit: number;
  max_limit: number;
  setModalLimitOpen: (value: boolean) => void;
  refetch: () => void;
};

export default function CustomerOrderAmountForm({
  id,
  min_limit,
  max_limit,
  setModalLimitOpen,
  modalLimitOpen,
  refetch,
}: Props) {
  const openModalUpdateLimitHandler = () => {
    setModalLimitOpen(true);
  };
  return (
    <WhiteBlock>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Title title='Лимит суммы заказа' />
        <Button
          className={styles.button}
          onClick={openModalUpdateLimitHandler}
          theme='filed'>
          Изменить
        </Button>
        <ModalUpdateLimit
          id={id || ''}
          isOpen={modalLimitOpen}
          onClose={() => setModalLimitOpen(false)}
          refetch={refetch}
        />
      </div>
      <div className={styles.inputBlock}>
        <InputText
          beneficiaries
          value={String(min_limit)}
          placeholder='минимальная сумма'
          price='₽'
          isDisabled
        />
        <InputText
          beneficiaries
          value={String(max_limit)}
          placeholder='максимальная сумма'
          price='₽'
          isDisabled
        />
      </div>
    </WhiteBlock>
  );
}
